/**
 * Renders a masked identifier (e.g. `********1234`) with one consistent glyph for every mask character.
 *
 * Inter enables contextual alternates by default, and its `calt` rules swap case-sensitive punctuation for a
 * taller, lower `.case` variant when a capital or digit follows within 5 positions. In a masked value that
 * converts only the last 5 asterisks, so the run visibly changes size and height partway through.
 */
export const maskedValueClassName = '[font-variant-ligatures:no-contextual]';
